import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (integrationCredentialId: ID) => {
  return {
    endpoint: `/integration_credentials/${integrationCredentialId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
